export default "__VITE_ASSET__O0nEV9yC__"